import React, { useEffect, useState } from "react";
import { Row, Col, Button } from "antd";
import { useNavigate } from "react-router-dom";
import "./index.less";
import { useDispatch, useSelector } from "react-redux";
import { setLabDetailsIsEdit } from "./redux/actions";
import LabsRegisterTable from "./labsRegisterTable";
import { PlusOutlined } from "@ant-design/icons";
import { fetchLabStatuses } from "../LabStatuses/redux/actions";
import ExportLabs from "./exportLabs";
import Tooltip from "../../components/tooltip-Custom";

const LabSetup = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authReducer);
  const [canUpdate, setCanUpdate] = useState(false);

  useEffect(() => {
    if (user?.permissions?.labs_setup?.add_edit) {
      setCanUpdate(true);
    }
  }, [user]);

  useEffect(() => {
    dispatch(fetchLabStatuses());
  }, []);

  return (
    <div className="page-top-div">
      <span className="text-span">Labs Setup</span>
      <Row className="production-manager-parent-row card-container">
        <Col span={24} className="heading-col">
          <Row align="middle" gutter={[50, 0]} justify="space-between">
            <Col>
              <Row align="middle" gutter={[80, 0]}>
                <Col>
                  <div>
                    <span className="heading-span">Labs Register</span>
                  </div>
                </Col>
                <Col>
                  {canUpdate && (
                    <Button
                      onClick={() => {
                        navigate("/labs-setup/create-lab");
                        dispatch(setLabDetailsIsEdit(true));
                      }}
                      icon={<PlusOutlined />}
                      className="add-user-btn"
                      size="middle"
                      style={{
                        width: "105%",
                        fontSize: "13px",
                        fontWeight: 600,
                      }}
                    >
                      LAB
                    </Button>
                  )}
                </Col>
              </Row>
            </Col>
            <Col>
              {user?.permissions?.labs_setup?.export && (
                <Tooltip text="Export">
                  <ExportLabs />
                </Tooltip>
              )}
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <LabsRegisterTable
            canUpdate={canUpdate}
            canDelete={user?.permissions?.labs_setup?.delete || false}
          />
        </Col>
      </Row>
    </div>
  );
};

export default LabSetup;
